import { render, staticRenderFns } from "./TheWrongScreenSize.vue?vue&type=template&id=8110af8e&scoped=true"
import script from "./TheWrongScreenSize.vue?vue&type=script&lang=js"
export * from "./TheWrongScreenSize.vue?vue&type=script&lang=js"
import style0 from "./TheWrongScreenSize.vue?vue&type=style&index=0&id=8110af8e&prod&lang=scss&scoped=true"
import style1 from "./TheWrongScreenSize.vue?vue&type=style&index=1&id=8110af8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8110af8e",
  null
  
)

export default component.exports